import React, { Component, createRef } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import commonUtil from "../../../../../../utils/commonUtil";
import Template from "./template";
import Link from "../../../../../../components/ZUILib/Link";
import SelectionTab from "../../../../../../components/ZUILib/SelectionTab";
import Image from "../../../../../../components/ZUILib/Image";
import TextInput from "../../../../../../components/ZUILib/TextInput";
import ProgressBar from "../../../../../../components/ZUILib/ProgressBar";
import ModalPopover from "../../../../../../components/ZUILib/ModalPopover";
import * as defaultConst from "../../../../../../utils/clientConstant";

import * as giftListActions from "../../actions";
import EmptyGiftListIndicator from "../EmptyGiftListIndicator";
import InputButton from "../../../../../../components/ZUILib/InputButton";
import ComprasModalOverlay from "./components/ComprasModalOverlay";

const { getTrackOrder, addAgainGiftItem, getRegisteredGiftList } = giftListActions;

const eventTypes = [
  defaultConst.eventType.Aniversario,
  defaultConst.eventType.Cumpleanos,
  defaultConst.eventType.Despedida,
  defaultConst.eventType.Fiesta_Infantil,
  defaultConst.eventType.Fiesta_Reunion,
  defaultConst.eventType.Open_House,
  defaultConst.eventType.Others,
  defaultConst.eventType.Mascotas,
];

class ComprasPersonales extends Component {
  constructor(props) {
    super(props);
    this.giftData = "";
    this.scrollTargetRef = createRef();
    this.state = {
      filteringParameters: this.props.filterParamsPersonalShoppingList || [],
      sortingType: "",
      searchKeyword: "",
      searchFlag: true,
      originalPersonalShoppingList: _.isObject(props.originalPersonalShoppingList)
        ? props.originalPersonalShoppingList
        : { categoryList: [], filteringParameters: [], itemsInfo: [], links: [] },
      comprasModal: false,
      displaySelectedProductDetail: null,
      giftSectionType: null,
    };
    this.initialPersonalPurchaseList = props.initialPersonalPurchaseList || {};
  }

  componentWillReceiveProps(nextProps) {
    const nextOriginalPersonalShoppingList = nextProps.originalPersonalShoppingList;
    const prevOriginalPersonalShoppingList = this.props.originalPersonalShoppingList;
    const originalPersonalShoppingListDidChange = nextOriginalPersonalShoppingList !== prevOriginalPersonalShoppingList;
    if (originalPersonalShoppingListDidChange) this.setState({ originalPersonalShoppingList: nextOriginalPersonalShoppingList });
  }

  sortType = "";
  searchedValue = "";
  stage1class = "titleOrder";
  stage2class = "titleOrder";
  stage3class = "titleOrder";
  stage4class = "titleOrder";
  trackOrder = (giftDetail) => {
    this.giftData = giftDetail;
    // this.props.getTrackOrder(this.props.eventId, giftDetail.purchaseItemId, '20237586');
    // this.props.getTrackOrder(this.props.eventId, '100008', '20237585');
    // this.props.getTrackOrder(this.props.eventId, giftDetail.purchaseItemId, giftDetail.pedidoNo);
    this.props
      .getTrackOrder(
        this.props.eventId,
        giftDetail.purchaseItemId,
        giftDetail.pedidoNo
      )
      .then((response) => {
        if (response.status === "success") {
          this.trackingModal.handleShow();
        } else {
          this.failureTrackingModal.handleShow();
        }
      });
  };
  dismissDelete = () => {
    this.failureTrackingModal.handleHide();
  };
  sortGiftList = () => {
    this.sortType = this.sortType === "Descending" ? "Ascending" : "Descending";
    this.setState({ sortingType: this.sortType });
    this.props.getPaginatedPersonalPurchases({
      searchKeyword: this.state.searchKeyword,
      priceOrder: this.sortType,
      filteringParameters: this.props.filterParamsPersonalShoppingList || this.state.filteringParameters,
    });
  };

  onSearchAreaKeyUp = (e) => {
    if (e.keyCode === 13) {
      // Service Call
      this.setState({
        searchKeyword: this.searchGift.getValue(),
        searchFlag: false,
      });
      this.props.getPaginatedPersonalPurchases({
        searchKeyword: this.searchGift.getValue(),
        priceOrder: this.state.sortingType,
        filteringParameters: this.props.filterParamsPersonalShoppingList || this.state.filteringParameters,
      });
      this.searchedValue = this.searchGift.getValue();
    }
    if (!e.target.value.length) {
      this.setState({ searchFlag: true });
      this.props.getPaginatedPersonalPurchases({
        priceOrder: this.state.sortingType,
        filteringParameters: this.props.filterParamsPersonalShoppingList || this.state.filteringParameters,
      });
    }
  };
  onClickSearchResult = () => {
    this.setState({
      searchKeyword: this.searchGift.getValue(),
      searchFlag: false,
    });
    this.props.getPaginatedPersonalPurchases({
      searchKeyword: this.searchGift.getValue(),
      priceOrder: this.state.sortingType,
      filteringParameters: this.props.filterParamsPersonalShoppingList || this.state.filteringParameters,
    });
    this.searchedValue = this.searchGift.getValue();
  };
  clearSearch = () => {
    this.setState({ searchKeyword: "", searchFlag: true });
    this.props.getPaginatedPersonalPurchases({
      priceOrder: this.state.sortingType,
      filteringParameters: this.props.filterParamsPersonalShoppingList || this.state.filteringParameters,
    });
    document.getElementById("searchAreaForPersonalGift").value = "";
  };

  // sortType = "Ascending";

  handleFilter = (type, value) => {
    let fpType = "";
    let isRemove = false;
    if (type === "deliveryMode") {
      fpType = "deliveryMode";
    } else if (type === "category") {
      fpType = "category";
    } else if (type === "bonusApplicable") {
      fpType = "bonusApplicable";
    }
    if (value === undefined) {
      isRemove = true;
    }
    this.updateFilterParams(fpType, value, isRemove);
  };
  updateFilterParams(fpType, value, isRemove) {
    const filteringParameters = this.state.filteringParameters;
    if (isRemove) {
      for (let i = 0; i < filteringParameters.length; i++) {
        if (filteringParameters[i].type === fpType) {
          filteringParameters.splice(i, 1);
        }
      }
    } else {
      const type = _.find(filteringParameters, { type: fpType });
      if (type) {
        type.value = value;
      } else {
        filteringParameters.push({ type: fpType, value });
      }
    }
    this.setState({
      filteringParameters,
    });
    this.props.getPaginatedPersonalPurchases({
      searchKeyword: this.state.searchKeyword,
      priceOrder: this.state.sortingType,
      filteringParameters,
    });
  }
  categoryOptions = (categoryOptionsInfo) => {
    const lookup = {};
    const items = categoryOptionsInfo;
    const result = [];
    let i = 0;
    /* eslint-disable */
    for (let item; (item = items[i++]); ) {
      const categoryInfo = item.name;
      const categoryInfoId = item.id;
      if (!(categoryInfo in lookup)) {
        lookup[categoryInfo] = 1;
        // lookup[categoryInfo] = 1;
        result.push({
          id: categoryInfoId,
          value: categoryInfo,
          labelResourceId: categoryInfo,
          disabled: false,
        });
      }
    }
    /* eslint-enable */
    return result;
  };


  hideModalOverlay = () => {
    this.setState({
      comprasModal: false,
      displaySelectedProductDetail: null,
      giftSectionType: null,
    })
    document.body.classList.remove('body-no-scroll');
  }

  showModalOverlay = (giftDetail, giftSection) => {
    this.setState({
      displaySelectedProductDetail: giftDetail,
      giftSectionType: giftSection,
      comprasModal: true
    })
  }

  addAgain = (skuId) => {
    addAgainGiftItem(this.props.eventId, skuId)
      .then((response) => {
        if (response.body.status?.status === 'success') {
          this.props.getRegisteredGiftList(
            this.props.eventId,
            this.props.registeredGiftListPriceOrder,
            '',
            '',
          );
          this.props.showMessagePopUp(
            true,
            false,
            true,
            commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              'adminpage.regalosrecibidos.gift.addagain.success.message',
            ),
          );
        } else {
          this.props.showMessagePopUp(
            false,
            false,
            true,
            commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              'adminpage.regalosrecibidos.add.again.failure.message',
            ),
          );
        }

        this.hideModalOverlay();

        if (this.scrollTargetRef.current) {
          this.scrollTargetRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      })
      .catch((e) => {
        console.log(e);
        if (e.body && e.body.detail) {
          this.props.showMessagePopUp(false, false, true, e.body.detail);
        }
      });
  };

  render() {
    const {
      itemsInfo: personalPurchases = [],
      filteringParameters,
      itemsCount: totalPersonalPurchases,
      totalRecordsShowed,
      searchKeyword,
    } = this.state.originalPersonalShoppingList;
    const listIsEmpty = _.isNumber(Number(totalPersonalPurchases)) && Number(totalPersonalPurchases) <= 0;

    let personalShoppingList = [];
    const { personalItemsInfo, filterParamsPersonalShoppingList } = this.props;
    if (this.props.personalShoppingList) {
      personalShoppingList = this.props.personalShoppingList;
    }
    const CategoryOptions = {
      id: "categoryOptions",
      disable: false,
      defaultValue: "Todas las categorías",
      options: personalShoppingList.categoryList
        ? this.categoryOptions(this.props.comprasCategory)
        : [], // personalShoppingList.categoryList ? this.categoryOptions(personalShoppingList.categoryList) : [],
    };
    const SelectionOptions4 = {
      options: [
        {
          option: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.comparas.bonus.applicable.label"
          ),
          value: "1",
          disabled: false,
          selected: false,
        },
        {
          option: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.comparas.bonus.not.applicable.label"
          ),
          value: "0",
          disabled: false,
          selected: false,
        },
      ],
    };

    const SortArticleButton = {
      type: 'button',
      id: 'sortArticle',
      style: 'mobileWhiteButton',
      value: this.state.sortingType === 'Ascending' ? commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.lowest.label'): commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.label'),
      disabled: !personalShoppingList,
      cssStyle: { opacity: personalShoppingList ? '100%' : '33%' },
      beforeIconClass: 'icon-swap',
      imageClass: commonUtil.getAssetURL() + '/images/expand_more.svg'
    };
    const LinkJSONPrice = {
      href: 'javascript:void(0);',
      displayName: '',
      onClickHandler: () => {
        const show = document.querySelector('#personal .giftList-sort-modal').style.display;
        if (show === 'none') {
          document.querySelector('#personal .giftList-sort-modal').style.display = 'block';
        } else {
          document.querySelector('#personal .giftList-sort-modal').style.display = 'none';
        }
      },
    };

    const priceSorting = [{
      "id": 'Ascending',
      "value": commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.ascending')
    }, {
      "id": 'Descending',
      "value": commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.descending')
    }
    ]

    const handleSwitchRadio = (id) => {
      this.sortType = id,
        this.props.getPaginatedPersonalPurchases({
          searchKeyword: this.state.searchKeyword,
          priceOrder: this.sortType,
          filteringParameters: this.props.filterParamsPersonalShoppingList || this.state.filteringParameters,
        });
      this.props.sorting(this.sortType);
      this.setState({ sortingType: this.sortType });
      document.querySelector('#personal .giftList-sort-modal').style.display = 'none';
    }


   
    const imageAttrTracker = {
      id: "img1",
      src: this.giftData.imageURL,
      className: "imageTracing",
      altImg: commonUtil.getAssetURL() + "/images/guest/no-image.png",
    };
    const totalRecords = personalShoppingList.itemsCount;
    const loadedRecordCount = personalItemsInfo ? personalItemsInfo.length : 0;
    const currentPage = personalShoppingList.currentPage;
    const sortType = this.state.sortingType;
    this.props.setTotalRecordsForType(
      "tabpersonal",
      totalRecords,
      loadedRecordCount,
      sortType,
      currentPage
    );

    const html = personalPurchases.map((giftDetail, index) => (
      <Template
        eventType={this.props.eventType}
        compareEventStatus={this.props.compareEventStatus}
        key={index}
        trackOrder={this.trackOrder}
        giftDetail={giftDetail}
        eventId={this.props.eventId}
        lables={this.props.lables}
        selectedProductForPreview={this.showModalOverlay}
        eventStatus={this.props.eventStatus}
        addAgain={this.addAgain}
        showMessagePopUp={this.props.showMessagePopUp}
        selectedTheme={this.props.selectedTheme}
        eventContractInfo={this.props.eventInfo.contractInfo}
      />
    ));

    const trackInfo = this.props.trackOrderInfo;
    const trackInfoPrice =
      trackInfo && trackInfo.orderTrackInfo && trackInfo.orderTrackInfo.price
        ? commonUtil.getCurrency(trackInfo.orderTrackInfo.price)
        : "";
    const trackOrderURL =
      trackInfo &&
      trackInfo.orderTrackInfo &&
      trackInfo.orderTrackInfo.tplRedirectionURL &&
      trackInfo.orderTrackInfo.trackingNumber
        ? trackInfo.orderTrackInfo.tplRedirectionURL +
          trackInfo.orderTrackInfo.trackingNumber
        : "";
    if (
      trackInfo &&
      trackInfo.orderTrackInfo &&
      trackInfo.orderTrackInfo.stageLevel
    ) {
      if (trackInfo.orderTrackInfo.stageLevel === "Stage1") {
        this.progressBar = 25;
        this.stage1class += " orderDelivered";
      } else if (trackInfo.orderTrackInfo.stageLevel === "Stage2") {
        this.progressBar = 50;
        this.stage1class += " orderDelivered";
        this.stage2class += " orderDelivered";
      } else if (trackInfo.orderTrackInfo.stageLevel === "Stage3") {
        this.progressBar = 75;
        this.stage1class += " orderDelivered";
        this.stage2class += " orderDelivered";
        this.stage3class += " orderDelivered";
      } else {
        this.progressBar = 100;
        this.stage1class += " orderDelivered";
        this.stage2class += " orderDelivered";
        this.stage3class += " orderDelivered";
        this.stage4class += " orderDelivered";
      }
    }
    return (
      <div className="row">
        <input type="hidden" value={totalRecords} id="personalRecordCount" />
        <input
          type="hidden"
          value={loadedRecordCount}
          id="loadedPersonalRecordCount"
        />
         <div className="col-md-12">
          {
          this.state.comprasModal && 
          <ComprasModalOverlay 
            isComprasModal={true}
            title={commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.comparas.modal.header.label')}
            hideModalOverlay={this.hideModalOverlay}
            giftSectionType={this.state.giftSectionType}
            selectedProduct={this.state.displaySelectedProductDetail} 
            eventId={this.props.eventId}
            lables={this.props.lables}
            compareEventStatus={this.props.compareEventStatus}
            eventType={this.props.eventType}
            filterParams={this.props.filterParamsPersonalShoppingList}
            addAgain={this.addAgain}
            showMessagePopUp={this.props.showMessagePopUp}
            selectedTheme={this.props.selectedTheme}
          />
        }
       {(!listIsEmpty || !_.isEmpty(filterParamsPersonalShoppingList) || !_.isEmpty(searchKeyword)) && (
            <div className="row invitedListGiftRegister">
            <div className="col-md-12 col-sm-12">
             { (searchKeyword || totalRecords >0) && (
                <>
              <div className="col-sm-4"></div>
              <div className="col-md-4 col-sm-4 invitedListSearch buscarwrapper">
                <div className="input-group">
                <TextInput
                  className="form-control"
                  htmlId="searchAreaForPersonalGift"
                  placeholder="Buscar por producto o categoría"
                  required="true"
                  star=""
                  ref={(txt) => (this.searchGift = txt)}
                  onKeyUp={this.onSearchAreaKeyUp}
                />
                <span className="input-group-btn">
                  {this.state.searchFlag ? (
                    <span
                      className="btn btn-default buttonSearch"
                      onClick={this.onClickSearchResult}
                    >
                      <i className="icon-zoom" aria-hidden="true" />
                    </span>
                  ) : (
                    <span
                      className="btn btn-default buttonSearch"
                      onClick={this.clearSearch}
                    >
                      <i className="iClass icon-tache2" aria-hidden="true" />
                    </span>
                  )}
                </span>
              </div>
              </div>
            </>
            )}
              <div className="col-sm-4"></div>
              <div className="row">
                  {!listIsEmpty && (               
                    <div className="col-xs-12 giftList-filters">
                <div className="row">
                  <div className='col-xs-7'></div>
                  <div className="col-xs-4 pull-right sort-container">
                    <div className='giftList-sort-div'>
                      <div className='giftList-sort'>
                        <Link linkJSON={LinkJSONPrice}>
                          <InputButton buttonAttr={SortArticleButton} />
                        </Link>
                      </div>
                      <div className="giftList-sort-modal" style={{ display: 'none' }}>
                         {priceSorting.map((option, index) => (
                          <div key={index} id={option.id} onClick={() => handleSwitchRadio(option.id)} className={`sort-option ${this.sortType === option.id ? 'active' : ''}`}>
                            <span className="radio-icon" />
                            <span className="lable-txt">{option.value}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                    </div>)}
              </div>
            </div>
            </div>
         )}
         {!listIsEmpty && (
            <div className="col-xs-12 text-right giftList-total-records">
              <b>{totalRecordsShowed} de {totalPersonalPurchases}</b> productos
            </div>
          )}
        </div>
        {/* {(!listIsEmpty || !_.isEmpty(filteringParameters) || !_.isEmpty(searchKeyword)) && (
          <div className="col-md-12">
            <div className="col-md-3">
              <div className="btn-group btnGroupGift">
                <SelectionTab
                  classname="cSelect filters"
                  id="giftListCategoría"
                  options={CategoryOptions.options}
                  optionCaption={commonUtil.getLabel(
                    this.props.lables.EventAdminPage,
                    "adminpage.comparas.category.dropdown.label"
                  )}
                  optionText={"value"}
                  optionValue={"value"}
                  isCaptionDisabled={false}
                  handleSelectedOption={(filter) =>
                    this.handleFilter("category", filter.id)
                  }
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="btn-group btnGroupGift">
                {!this.props.compareEventStatus(
                  this.props.eventType,
                  eventTypes
                ) ? (
                  <SelectionTab
                    classname="cSelect filters"
                    id="giftListBonificación"
                    options={SelectionOptions4.options}
                    optionCaption={commonUtil.getLabel(
                      this.props.lables.EventAdminPage,
                      "adminpage.comparas.bonus.dropdown.label"
                    )}
                    optionText={"option"}
                    optionValue={"option"}
                    isCaptionDisabled={false}
                    handleSelectedOption={(filter) =>
                      this.handleFilter("bonusApplicable", filter.value)
                    }
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="col-md-6 invitedListSearch">
              
            </div>
          </div>
        )} */}

       
        {!listIsEmpty && (
          <div className="col-md-12">

            
            <div className="tablePersonalShopping">
              <div className="gift-card-head">
                  <div className="row">
                    <div className="col-md-6 col-sm-6">
                      <div className="giftList-image">&nbsp;</div>
                      <div className="giftList-productDetails">
                        {commonUtil.getLabel(this.props.lables.EventAdminPage,"adminpage.regalosrecibidos.articulo.label")}
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12 pl-0">
                      <div className="row">
                        <div className="col-sm-3">
                          <div>{commonUtil.getLabel(this.props.lables.EventAdminPage,"adminpage.regalosregistrados.price.label")}</div>
                        </div>
                        <div className="col-sm-9 pl-0">
                          <div>{commonUtil.getLabel(this.props.lables.EventAdminPage,"adminpage.comparas.purchase.label")}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              {/* <thead className="rowLines">
                <tr>
                  <td className="headImgInner" />
                  <td className="textToLeft">Producto</td>
                  <td className="headPriceInner text-center">
                    <Link linkJSON={LinkJSONPrice}>
                      <span className="tooltip-container">
                        {commonUtil.getLabel(
                          this.props.lables.EventAdminPage,
                          "adminpage.comparas.price.label"
                        )}
                        <span className="tooltip-box">
                          {commonUtil.getLabel(
                            this.props.lables.EventAdminPage,
                            "adminpage.comparas.price.tooltip.label"
                          )}
                        </span>
                      </span>
                      &nbsp;
                      {this.state.sortingType === "Descending" ? (
                        <i
                          className="icon-flecha_filtros_abajo"
                          aria-hidden="true"
                        />
                      ) : (
                        <i
                          className="icon-flecha_filtros_arriba"
                          aria-hidden="true"
                        />
                      )}
                    </Link>
                  </td>
                  <td className="headQuantityInner">
                    <a href>
                      {commonUtil.getLabel(
                        this.props.lables.EventAdminPage,
                        "adminpage.comparas.qty.label"
                      )}
                    </a>
                  </td>
                  <td className="textToLeft headDetailInner">
                    <a href>
                      {commonUtil.getLabel(
                        this.props.lables.EventAdminPage,
                        "adminpage.comparas.purchase.label"
                      )}
                    </a>
                  </td>
                  {!this.props.compareEventStatus(
                    this.props.eventType,
                    eventTypes
                  ) ? (
                    <td className="headIconInner tooltip-container">
                      <a href>
                        {commonUtil.getLabel(
                          this.props.lables.EventAdminPage,
                          "adminpage.comparas.bonus.label"
                        )}
                      </a>
                      <span className="tooltip-box">
                        {commonUtil.getLabel(
                          this.props.lables.EventAdminPage,
                          "adminpage.comparas.bonus.tooltip.label"
                        )}
                      </span>
                    </td>
                  ) : (
                    ""
                  )}
                </tr>
              </thead> */}
              {personalItemsInfo && personalItemsInfo.length > 0 ? (
                <div>{html}</div>
              ) : (
                <React.Fragment>
                  {this.searchedValue && this.searchedValue !== "" ? (
                    <p>
                      {commonUtil.getLabel(
                        this.props.lables.EventAdminPage,
                        "adminpage.comparas.your.research.label"
                      )}{" "}
                      {this.searchedValue}{" "}
                      {commonUtil.getLabel(
                        this.props.lables.EventAdminPage,
                        "adminpage.comparas.zero.results"
                      )}
                    </p>
                  ) : (
                    <p>
                      {commonUtil.getLabel(
                        this.props.lables.EventAdminPage,
                        "adminpage.comparas.zero.search.results"
                      )}
                    </p>
                  )}
                </React.Fragment>
              )}
            </div>
          </div>
        )}
        {listIsEmpty && (
          <EmptyGiftListIndicator giftList={`${this.initialPersonalPurchaseList.totalRecords == 0 ? "personalPurchases" : "personalPurchases_noSearchResults"}`} style={{ padding: '3rem 0' }} />
        )}
        <ModalPopover
          modalId="tracingModal"
          isModal="true"
          ref={(trackingModal) => (this.trackingModal = trackingModal)}
        >
          <button
            id="closeModal"
            className="btnClose"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
          >
            <i>×</i>
          </button>
          <h4>
            {commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.comparas.delivery.tracking.label"
            )}
          </h4>
          <div className="row">
            <div className="headerTracing">
              <div className="col-md-3 col-sm-3 contentTracing">
                <p className="titleTracing">
                  {commonUtil.getLabel(
                    this.props.lables.EventAdminPage,
                    "adminpage.comparas.date.of.purchase.by.label"
                  )}
                </p>
                <p className="subTracing textToBold">
                  {trackInfo &&
                  trackInfo.orderTrackInfo &&
                  trackInfo.orderTrackInfo.dateOfPurchase
                    ? commonUtil.formatDate(
                        commonUtil.formatServiceDate(
                          trackInfo.orderTrackInfo.dateOfPurchase
                        ),
                        "monthName"
                      )
                    : ""}
                </p>
              </div>
              <div className="col-md-2 col-sm-3 contentTracing">
                <p className="titleTracing">
                  {commonUtil.getLabel(
                    this.props.lables.EventAdminPage,
                    "adminpage.comparas.total.by.label"
                  )}
                </p>
                <p className="subTracing priceTag">{trackInfoPrice}</p>
              </div>
              <div className="col-md-2 col-sm-3 contentTracing">
                <p className="titleTracing">
                  {commonUtil.getLabel(
                    this.props.lables.EventAdminPage,
                    "adminpage.comparas.send to.by.label"
                  )}
                  :
                </p>
                <p className="subTracing textToBold">
                  {trackInfo &&
                  trackInfo.orderTrackInfo &&
                  trackInfo.orderTrackInfo.boughtFor
                    ? trackInfo.orderTrackInfo.boughtFor
                    : ""}
                </p>
              </div>
              <div className="col-md-2 col-sm-3 contentTracing">
                <p className="titleTracing">
                  {commonUtil.getLabel(
                    this.props.lables.EventAdminPage,
                    "adminpage.comparas.no.of.event.by.label"
                  )}
                  :
                </p>
                <p className="subTracing textToBold">{this.props.eventId}</p>
              </div>
              <div className="col-md-3 col-sm-3 contentTracing orderRequest">
                <p className="titleTracing">
                  {commonUtil.getLabel(
                    this.props.lables.EventAdminPage,
                    "adminpage.comparas.order.no.by.label"
                  )}
                  :{" "}
                  {trackInfo &&
                  trackInfo.orderTrackInfo &&
                  trackInfo.orderTrackInfo.pedidoNo
                    ? trackInfo.orderTrackInfo.pedidoNo
                    : ""}
                </p>
              </div>
            </div>
            <div className="col-md-12 col-sm-12">
              <div className="col-md-2 col-sm-2">
                <Image imageAttr={imageAttrTracker} />
              </div>
              <div className="col-md-10 col-sm-10">
                <p className="nameProduct">
                  {trackInfo &&
                  trackInfo.orderTrackInfo &&
                  trackInfo.orderTrackInfo.productName
                    ? trackInfo.orderTrackInfo.productName
                    : ""}
                </p>
                <p className="quantity subOrder">
                  {commonUtil.getLabel(
                    this.props.lables.EventAdminPage,
                    "adminpage.comparas.qty.label"
                  )}
                  :{" "}
                  {trackInfo &&
                  trackInfo.orderTrackInfo &&
                  trackInfo.orderTrackInfo.quantity
                    ? parseInt(trackInfo.orderTrackInfo.quantity, 10)
                    : ""}
                </p>
                <div className="progress progressBar">
                  <div
                    className="progress-bar progress-bar-info"
                    ref={(barWidht) => (this.barWidht = barWidht)}
                  >
                    <ProgressBar
                      percent={this.progressBar}
                      width={560}
                      height={20}
                    />
                  </div>
                </div>
                <div className="col-md-3 col-sm-3 pl-0">
                  <p className={this.stage1class}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage1Status
                      ? trackInfo.orderTrackInfo.stage1Status
                      : ""}
                    <i className="icon-caret_down tooltip-container">
                      <span className="tooltip-box">
                        {commonUtil.getLabel(
                          this.props.lables.EventAdminPage,
                          "adminpage.regalosrecibidos.trackorder.confirmed.order.tooltip"
                        )}
                      </span>{" "}
                    </i>
                  </p>
                  <p className="subOrder textToBold">
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage1Date
                      ? trackInfo.orderTrackInfo.stage1Date
                      : ""}
                  </p>
                </div>
                <div className="col-md-3 col-sm-3 pl-0">
                  <p className={this.stage2class}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage2Status
                      ? trackInfo.orderTrackInfo.stage2Status
                      : ""}
                    <i className="icon-caret_down tooltip-container">
                      <span className="tooltip-box">
                        {commonUtil.getLabel(
                          this.props.lables.EventAdminPage,
                          "adminpage.regalosrecibidos.trackorder.preparing.tooltip"
                        )}
                      </span>{" "}
                    </i>
                  </p>
                  <p className="subOrder textToBold">
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage2Date
                      ? trackInfo.orderTrackInfo.stage2Date
                      : ""}
                  </p>
                </div>
                <div className="col-md-3 col-sm-3 pl-0">
                  <p className={this.stage3class}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage3Status
                      ? trackInfo.orderTrackInfo.stage3Status
                      : ""}
                    <i className="icon-caret_down tooltip-container">
                      <span className="tooltip-box">
                        {commonUtil.getLabel(
                          this.props.lables.EventAdminPage,
                          "adminpage.regalosrecibidos.trackorder.ontheway.tooltip"
                        )}
                      </span>{" "}
                    </i>
                  </p>
                  <p className="subOrder textToBold">
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage3Date
                      ? trackInfo.orderTrackInfo.stage3Date
                      : ""}
                  </p>
                </div>
                <div className="col-md-3 col-sm-3 pl-0">
                  <p className={this.stage4class}>
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage4Status
                      ? trackInfo.orderTrackInfo.stage4Status
                      : ""}
                    <i className="icon-caret_down tooltip-container">
                      <span className="tooltip-box">
                        {" "}
                        {commonUtil.getLabel(
                          this.props.lables.EventAdminPage,
                          "adminpage.regalosrecibidos.trackorder.delivered.tooltip"
                        )}{" "}
                      </span>{" "}
                    </i>
                  </p>
                  <p className="subOrder textToBold">
                    {trackInfo &&
                    trackInfo.orderTrackInfo &&
                    trackInfo.orderTrackInfo.stage4Date
                      ? trackInfo.orderTrackInfo.stage4Date
                      : ""}
                  </p>
                </div>
              </div>
            </div>
            {trackInfo &&
            trackInfo.orderTrackInfo &&
            trackInfo.orderTrackInfo.trackingNumber !== "" ? (
              <div className="col-md-12 col-sm-12 footerTlo">
                <p>
                  {commonUtil.getLabel(
                    this.props.lables.EventAdminPage,
                    "adminpage.comparas.shipping.dhl.by.label"
                  )}{" "}
                  -{" "}
                  <span>
                    {commonUtil.getLabel(
                      this.props.lables.EventAdminPage,
                      "adminpage.comparas.guide.number.by.label"
                    )}
                    :{" "}
                    <a href={trackOrderURL}>
                      {trackInfo &&
                      trackInfo.orderTrackInfo &&
                      trackInfo.orderTrackInfo.trackingNumber
                        ? trackInfo.orderTrackInfo.trackingNumber
                        : ""}
                    </a>
                  </span>
                </p>
                {/* <i className="fa fa-angle-right" onClick={this.trackOrderLink} /> */}
              </div>
            ) : null}
          </div>
        </ModalPopover>
        <ModalPopover
          modalId="modalDelete"
          outerClass="modal-sm"
          isModal="true"
          ref={(failureTrackingModal) =>
            (this.failureTrackingModal = failureTrackingModal)
          }
          handleOutsideClick
          header
        >
          <div className="row text-align-center mb10">
            <div className="col-xs-12">
              <p>
                {commonUtil.getLabel(
                  this.props.lables.EventAdminPage,
                  "adminpage.compras.track.order.failure.message"
                )}
              </p>
            </div>
            <div className="col-sm-12">
              <button
                className="btnSecondaryAction size-Small"
                value="cancel"
                onClick={this.dismissDelete}
              >
                OK
              </button>
            </div>
            {/* </div> */}
          </div>
        </ModalPopover>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  trackOrderInfo: state.giftList.data.trackOrderInfo,
  eventStatus:
    state.giftList &&
    state.giftList.data &&
    state.giftList.data.eventSummaryInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo.eventStatus,
  eventType:
    state.giftList &&
    state.giftList.data &&
    state.giftList.data.eventSummaryInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo &&
    state.giftList.data.eventSummaryInfo.eventInfo.eventType,
  eventInfo: state.giftList?.data?.eventSummaryInfo?.eventInfo || {},
  registeredGiftListPriceOrder: state.giftList.data.registeredGiftList?.originalRegisteredGiftList?.priceOrder || 'Ascending',
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getTrackOrder,
      getRegisteredGiftList,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(ComprasPersonales);
